{
  "longPressMessage": "Naciśnij i przytrzymaj, aby otworzyć podgląd"
}
